export default __webpack_public_path__ + "static/media/kitchen3-before2-2048w.cd6ecd47.avif";